export const SEARCH_TERM_PARAM_NAME = "search_term";
export const PAGE_PARAM_NAME = "page";
